













































































































































































import 'reflect-metadata'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { ParsedEVMTx } from '@/store/modules/transactions/helpers/parseEVMTxs'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import CopyText from '@/components/misc/CopyText.vue'
import Loader from '@/components/misc/Loader.vue'
import { toDCM, trimmedLocaleString } from '@/helper'
import Big from 'big.js'
import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK_NAME,
    HAS_SUBNET,
} from '@/store/modules/network/network'

// import { getBurnedC } from '@/services/burned/burned.service'

@Component({
    components: {
        CopyText,
        Loader,
    },
    filters: {
        toDCM,
        trimmedLocaleString,
    },
})
export default class EVMTransactionRow extends Mixins(
    TransactionsGettersMixin
) {
    @Prop() txs!: ParsedEVMTx[]
    // forTSP = false
    shortenText(source: string, index1: number, index2: number) {
        if (source.length < index1) return source

        return `${source.substring(0, index1)}...${source.substring(
            index2,
            source.length
        )}`
    }
    // created() {
    //     if (
    //         window.location.href.includes('blockchain') ||
    //         localStorage.getItem('isTSP')
    //     ) {
    //         this.forTSP = true
    //     }
    // }
    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    mounted() {
        // console.log(this.txs)
    }
    gasPrice(value: string) {
        return toDCM(value, 18).toFixed(9)
    }

    amount(value: string) {
        const amt = Big(toDCM(value))
        return trimmedLocaleString(amt, 9)
    }

    get isLoading() {
        return this.txs.length === 0
    }
}
